export function validateOrb(duration) {
  const candleDuration = Number(duration);
  if (candleDuration <= 0 || !Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number larger than zero.'];
  return [true, ''];
}
